import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2996c052"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold mb-4" }
const _hoisted_3 = {
  key: 1,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_7 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_8 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_9 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_10 = { class: "col-lg-12" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_13 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_14 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_15 = { class: "row mx-0 px-0 col-lg-9" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-lg-4" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-lg-12" }
const _hoisted_21 = { class: "fs-8" }
const _hoisted_22 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_23 = { class: "w-max-content col-lg-3 col-form-label fw-bold" }
const _hoisted_24 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_25 = { class: "col-lg-12" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = { class: "fs-8" }
const _hoisted_28 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_29 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_30 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_31 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_32 = { class: "col-lg-12" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_35 = { class: "w-max-content col-lg-3 col-form-label fw-bold" }
const _hoisted_36 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_37 = { class: "col-lg-6" }
const _hoisted_38 = { class: "form-check-label fs-7 text-nowrap" }
const _hoisted_39 = ["placeholder"]
const _hoisted_40 = { class: "fs-8" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6" }, null, -1))
const _hoisted_42 = { class: "col-lg-9" }
const _hoisted_43 = { class: "form-check-label fs-7 text-nowrap" }
const _hoisted_44 = ["placeholder"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-8" }, null, -1))
const _hoisted_46 = { class: "col-lg-6" }
const _hoisted_47 = { class: "form-check-label fs-7 text-nowrap" }
const _hoisted_48 = ["placeholder"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-8" }, null, -1))
const _hoisted_50 = { class: "col-lg-6" }
const _hoisted_51 = { class: "form-check-label fs-7 text-nowrap" }
const _hoisted_52 = ["placeholder"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-8" }, null, -1))
const _hoisted_54 = { class: "col-lg-6" }
const _hoisted_55 = { class: "form-check-label fs-7 text-nowrap" }
const _hoisted_56 = ["placeholder"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-8" }, null, -1))
const _hoisted_58 = { class: "col-lg-6" }
const _hoisted_59 = { class: "form-check-label fs-7 text-nowrap" }
const _hoisted_60 = ["placeholder"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-8" }, null, -1))
const _hoisted_62 = { class: "col-lg-6" }
const _hoisted_63 = { class: "form-check-label fs-7 text-nowrap" }
const _hoisted_64 = ["placeholder"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-8" }, null, -1))
const _hoisted_66 = { class: "col-lg-6" }
const _hoisted_67 = { class: "form-check-label fs-7 text-nowrap" }
const _hoisted_68 = ["placeholder"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-8" }, null, -1))
const _hoisted_70 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_71 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_72 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_73 = { class: "col-lg-6" }
const _hoisted_74 = ["for"]
const _hoisted_75 = ["id", "value"]
const _hoisted_76 = { class: "fs-8" }
const _hoisted_77 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_78 = { class: "w-max-content col-lg-3 col-form-label fw-bold" }
const _hoisted_79 = { class: "col-lg-6" }
const _hoisted_80 = { class: "d-flex align-items-center py-2" }
const _hoisted_81 = { class: "col-lg-3 form-check me-4" }
const _hoisted_82 = {
  class: "form-check-label fs-7 text-nowrap",
  for: "alumniCodeInvite"
}
const _hoisted_83 = { class: "col-lg-3 form-check me-4" }
const _hoisted_84 = {
  class: "form-check-label fs-7 text-nowrap",
  for: "employeeCodeInvite"
}
const _hoisted_85 = { class: "fs-8" }
const _hoisted_86 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_87 = { class: "w-max-content col-lg-3 col-form-label fw-bold" }
const _hoisted_88 = { class: "col-lg-6" }
const _hoisted_89 = { class: "d-flex align-items-center py-2" }
const _hoisted_90 = { class: "col-lg-3 form-check me-4" }
const _hoisted_91 = {
  class: "form-check-label fs-7 text-nowrap",
  for: "alumniGroupCreate"
}
const _hoisted_92 = { class: "col-lg-3 form-check me-4" }
const _hoisted_93 = {
  class: "form-check-label fs-7 text-nowrap",
  for: "employeeGroupCreate"
}
const _hoisted_94 = { class: "fs-8" }
const _hoisted_95 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_96 = { class: "w-max-content col-lg-3 col-form-label fw-bold" }
const _hoisted_97 = { class: "col-lg-6" }
const _hoisted_98 = { class: "d-flex align-items-center py-2" }
const _hoisted_99 = { class: "col-lg-3 form-check me-4" }
const _hoisted_100 = {
  class: "form-check-label fs-7 text-nowrap",
  for: "interestingRecruitment"
}
const _hoisted_101 = { class: "col-lg-3 form-check me-4" }
const _hoisted_102 = {
  class: "form-check-label fs-7 text-nowrap",
  for: "interestingJobOffer"
}
const _hoisted_103 = { class: "fs-8" }
const _hoisted_104 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_105 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_106 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_107 = { class: "col-lg-6" }
const _hoisted_108 = ["for"]
const _hoisted_109 = ["id", "value"]
const _hoisted_110 = { class: "fs-8" }
const _hoisted_111 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_112 = { class: "w-max-content col-lg-3 col-form-label fw-bold" }
const _hoisted_113 = { class: "col-lg-6" }
const _hoisted_114 = { class: "d-flex align-items-center py-2" }
const _hoisted_115 = { class: "col-lg-3 form-check me-4" }
const _hoisted_116 = {
  class: "form-check-label fs-7 text-nowrap",
  for: "settingComment"
}
const _hoisted_117 = { class: "col-lg-3 form-check me-4" }
const _hoisted_118 = {
  class: "form-check-label fs-7 text-nowrap",
  for: "settingMention"
}
const _hoisted_119 = { class: "d-flex align-items-center py-2" }
const _hoisted_120 = { class: "col-lg-3 form-check me-4" }
const _hoisted_121 = {
  class: "form-check-label fs-7 text-nowrap",
  for: "settingChatting"
}
const _hoisted_122 = { class: "col-lg-3 form-check me-4" }
const _hoisted_123 = {
  class: "form-check-label fs-7 text-nowrap",
  for: "settingInterested"
}
const _hoisted_124 = { class: "fs-8" }
const _hoisted_125 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_126 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_127 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_128 = { class: "col-lg-6" }
const _hoisted_129 = ["for"]
const _hoisted_130 = ["id", "value"]
const _hoisted_131 = { class: "fs-8" }
const _hoisted_132 = {
  key: 0,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_133 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_134 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_135 = { class: "col-lg-6 radio-group" }
const _hoisted_136 = ["id", "value"]
const _hoisted_137 = ["for"]
const _hoisted_138 = { class: "fs-8 ps-1" }
const _hoisted_139 = { class: "d-flex justify-content-center" }

import { computed, onMounted, ref, watchEffect, nextTick } from 'vue'
import { required, requiredIf } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import { debounce } from 'lodash'

import Status from '@/components/status/index.vue'
import UploadImage from '@/components/upload-image/index.vue'
import ConfirmModal from '@/views/community-admin/edit-community/components/ConfirmModal.vue'
import CreateSuccessModal from '@/views/community-admin/edit-community/components/CreateSuccessModal.vue'
import Button from '@/components/button/index.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import { Modal } from 'bootstrap'

//validate
import { countCharInSurrogatePair, customMaxLength, scrollToErrors } from '@/utils'
import ErrorMessage from '@/components/error-message/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'

//constant
import { translate } from '@/languages/i18n'
import { REGEX_EMOJI, validSimpleUrl } from '@/constants/regex'
import { COMMUNITY_STORE } from '@/store/constants'
import { MAX_UPLOAD_FILE_SIZE_MB, MAX_UPLOAD_FILE_SIZE_BYTES } from '@/constants/number'
import commonService from '@/services/common.service'
import { YELLOOP_CHECK_FOLLOW_SETTING_LIST } from '@/constants/index'

type IMG = { file: string; imgPreview: string; imgData: any }

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()

const serverError = ref<boolean>(false)

const dataCommunity = computed(() => store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO])
const modalEditConfirm = ref()

onMounted(() => {
  store.dispatch(COMMUNITY_STORE.ACTIONS.SET_COMMUNITY_INFO, router.currentRoute.value.params?.id)
  modalEditConfirm.value = new Modal(document.getElementById('modalConfirmCommunity'))
})

const headerLogoImage = ref<IMG>({ file: '', imgPreview: '', imgData: '' })

const setHeaderLogoImage = (file: string, imgPreview: string, imgData: any): void => {
  headerLogoImage.value = { file, imgPreview, imgData }
}

const setModelImage = (type: string, value: string) => {
  v$.value[type].$model = value
}

const officeProfileImage = ref<IMG>({ file: '', imgPreview: '', imgData: '' })

const setOfficeProfileImage = (file: string, imgPreview: string, imgData: any): void => {
  officeProfileImage.value = { file, imgPreview, imgData }
}

const showMessageError = (status: boolean): void => {
  serverError.value = status
}
const rules = computed(() => {
  return {
    name: {
      required,
      maxLength: (value: string) => customMaxLength(value, 30),
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
    display_corporation_name: {
      required,
      maxLength: (value: string) => customMaxLength(value, 30),
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
    operating_name: {
      maxString: (value: string) => customMaxLength(value, 30),
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
    description: {
      required,
      textAreaMaxLength: function (value) {
        if (value === dataCommunity.value?.description) return true
        if (countCharInSurrogatePair(value) <= 200) return true
        return false
      },
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
    message_board_title: {
      maxString: (value: string) => customMaxLength(value, 20),
    },
    message_board_content: {
      maxString: function (value) {
        if (value === dataCommunity.value?.message_board_content) return true
        if (countCharInSurrogatePair(value) <= 1000) return true
        return false
      },
      withoutContent: function (value: string) {
        // message_board_contentが空でURL①～③が入力されていた場合エラー
        if (!value && (formData.value.message_board_site_url_1 || formData.value.message_board_site_url_2 || formData.value.message_board_site_url_3)) {
          return false
        }
        return true
      },
    },
    message_board_site_name_1: {
      maxString: (value: string) => customMaxLength(value, 100),
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
    message_board_site_name_2: {
      maxString: (value: string) => customMaxLength(value, 100),
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
    message_board_site_name_3: {
      maxString: (value: string) => customMaxLength(value, 100),
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
    message_board_site_url_1: {
      maxString: (value: string) => customMaxLength(value, 4096),
      inputUrl: function (value) {
        if (!formData.value.message_board_site_name_1) {
          return true
        }
        return !value ? false : true
      },
      validUrl: function (value) {
        if (!value) {
          return true
        }
        return validSimpleUrl(value)
      },
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
    message_board_site_url_2: {
      maxString: (value: string) => customMaxLength(value, 4096),
      inputUrl: function (value) {
        if (!formData.value.message_board_site_name_2) {
          return true
        }
        return !value ? false : true
      },
      validUrl: function (value) {
        if (!value) {
          return true
        }
        return validSimpleUrl(value)
      },
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
    message_board_site_url_3: {
      maxString: (value: string) => customMaxLength(value, 4096),
      inputUrl: function (value) {
        if (!formData.value.message_board_site_name_3) {
          return true
        }
        return !value ? false : true
      },
      validUrl: function (value) {
        if (!value) {
          return true
        }
        return validSimpleUrl(value)
      },
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
    published: { required },
    pending_notice: { required },
    unsupported_operations_notice: { required },
    yelloop_check_update_follow_setting: {
      requiredSelect: requiredIf(dataCommunity.value?.yelloop_check_enable),
    },
    image_url: {
      checkTypeImage: function (value) {
        if (value) {
          return ['image/png', 'image/jpeg', 'image/jpg'].includes(value.type)
        }
        return true
      },
      fileSizeValidation: function (value) {
        if (value) {
          return value.size <= MAX_UPLOAD_FILE_SIZE_BYTES
        }
        return true
      },
    },
    profile_image_url: {
      checkTypeImage: function (value) {
        if (value) {
          return ['image/png', 'image/jpeg', 'image/jpg'].includes(value.type)
        }
        return true
      },
      fileSizeValidation: function (value) {
        if (value) {
          return value.size <= MAX_UPLOAD_FILE_SIZE_BYTES
        }
        return true
      },
    },
  }
})

const formData = ref({
  name: '',
  display_corporation_name: '',
  operating_name: '',
  description: '',
  message_board_title: '',
  message_board_content: '',
  message_board_site_name_1: '',
  message_board_site_name_2: '',
  message_board_site_name_3: '',
  message_board_site_url_1: '',
  message_board_site_url_2: '',
  message_board_site_url_3: '',
  image_url: '',
  profile_image_url: '',
  published: true,
  pending_notice: true,
  unsupported_operations_notice: true,
  can_use_invited_code_of_alumni_users: true,
  can_use_invited_code_of_employee_users: true,
  group_creation_by_alumni_users: true,
  group_creation_by_employee_users: true,
  interest_display_setting_recruitment: true,
  interest_display_setting_joboffer: true,
  immediately_notice_setting_comment: true,
  immediately_notice_setting_mention: true,
  immediately_notice_setting_chatting: true,
  immediately_notice_setting_interested: true,
  yelloop_check_update_follow_setting: 1,
})

const initImage = ref({
  image_url: '',
  profile_image_url: '',
})

watchEffect(() => {
  formData.value = {
    name: dataCommunity.value?.name || '',
    display_corporation_name: dataCommunity.value?.display_corporation_name || '',
    operating_name: dataCommunity.value?.operating_name || '',
    description: dataCommunity.value?.description || '',
    message_board_title: dataCommunity.value?.message_board_title || '',
    message_board_content: dataCommunity.value?.message_board_content || '',
    message_board_site_name_1: dataCommunity.value?.message_board_site_name_1 || '',
    message_board_site_name_2: dataCommunity.value?.message_board_site_name_2 || '',
    message_board_site_name_3: dataCommunity.value?.message_board_site_name_3 || '',
    message_board_site_url_1: dataCommunity.value?.message_board_site_url_1 || '',
    message_board_site_url_2: dataCommunity.value?.message_board_site_url_2 || '',
    message_board_site_url_3: dataCommunity.value?.message_board_site_url_3 || '',
    published: dataCommunity.value?.published,
    pending_notice: dataCommunity.value?.pending_notice,
    unsupported_operations_notice: dataCommunity.value?.unsupported_operations_notice,
    can_use_invited_code_of_alumni_users: dataCommunity.value?.can_use_invited_code_of_alumni_users,
    can_use_invited_code_of_employee_users: dataCommunity.value?.can_use_invited_code_of_employee_users,
    group_creation_by_alumni_users: dataCommunity.value?.group_creation_by_alumni_users,
    group_creation_by_employee_users: dataCommunity.value?.group_creation_by_employee_users,
    interest_display_setting_recruitment: dataCommunity.value?.interest_display_setting_recruitment,
    interest_display_setting_joboffer: dataCommunity.value?.interest_display_setting_joboffer,
    immediately_notice_setting_comment: dataCommunity.value?.immediately_notice_setting_comment,
    immediately_notice_setting_mention: dataCommunity.value?.immediately_notice_setting_mention,
    immediately_notice_setting_chatting: dataCommunity.value?.immediately_notice_setting_chatting,
    immediately_notice_setting_interested: dataCommunity.value?.immediately_notice_setting_interested,
    yelloop_check_update_follow_setting: dataCommunity.value?.yelloop_check_update_follow_setting || 1,
  }
  initImage.value = {
    image_url: dataCommunity.value?.image_url || '',
    profile_image_url: dataCommunity.value?.profile_image_url || '',
  }
})

const v$ = useVuelidate(rules, formData)
const loading = ref(false)
const onSubmit = async (): Promise<void> => {
  loading.value = true
  v$.value.$validate()
  if (v$.value.$invalid) {
    loading.value = false
    nextTick(() => {
      scrollToErrors()
    })
    return
  }

  isCheckedNgWord.messageBoardTitle = false
  isCheckedNgWord.messageBoardContent = false
  isCheckedNgWord.messageBoardSiteName1 = false
  isCheckedNgWord.messageBoardSiteName2 = false
  isCheckedNgWord.messageBoardSiteName3 = false
  await checkNgWordMessageBoardTitle()
  await checkNgWordMessageBoardContent()
  await checkNgWordMessageBoardSiteName1()
  await checkNgWordMessageBoardSiteName2()
  await checkNgWordMessageBoardSiteName3()
  while (
    !isCheckedNgWord.messageBoardTitle ||
    !isCheckedNgWord.messageBoardContent ||
    !isCheckedNgWord.messageBoardSiteName1 ||
    !isCheckedNgWord.messageBoardSiteName2 ||
    !isCheckedNgWord.messageBoardSiteName3
  ) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (
    ngWordMessageBoardTitle.value ||
    ngWordMessageBoardContent.value ||
    ngWordMessageBoardSiteName1.value ||
    ngWordMessageBoardSiteName2.value ||
    ngWordMessageBoardSiteName3.value
  ) {
    loading.value = false
    nextTick(() => {
      scrollToErrors()
    })
    return
  }

  window.scroll(0, 0)
  modalEditConfirm.value.show()
  loading.value = false
}

const radioList = [
  {
    title: translate('public'),
    status: true,
  },
  {
    title: translate('private'),
    status: false,
  },
]

const NoticeRadioList = [
  {
    unsupported_operations_notice_key: 'unsupported_operations_notice_receive',
    title: translate('receive'),
    status: true,
  },
  {
    unsupported_operations_notice_key: 'unsupported_operations_notice_not_receive',
    title: translate('notReceive'),
    status: false,
  },
]

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('settings'),
    to: '',
    active: false,
  },
  {
    content: translate('community'),
    to: '',
    active: true,
  },
]
const isCheckedNgWord = {
  messageBoardTitle: false,
  messageBoardContent: false,
  messageBoardSiteName1: false,
  messageBoardSiteName2: false,
  messageBoardSiteName3: false,
}
const ngWordMessageBoardTitle = ref<boolean>(false)
const ngWordMessageBoardContent = ref<boolean>(false)
const ngWordMessageBoardSiteName1 = ref<boolean>(false)
const ngWordMessageBoardSiteName2 = ref<boolean>(false)
const ngWordMessageBoardSiteName3 = ref<boolean>(false)
const checkNgWordMessageBoardTitle = debounce(async () => {
  const queryData = { sentence: v$.value.message_board_title.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngWordMessageBoardTitle.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNgWord.messageBoardTitle = true
  }
}, 200)
const checkNgWordMessageBoardContent = debounce(async () => {
  const queryData = { sentence: v$.value.message_board_content.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngWordMessageBoardContent.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNgWord.messageBoardContent = true
  }
}, 200)
const checkNgWordMessageBoardSiteName1 = debounce(async () => {
  const queryData = { sentence: v$.value.message_board_site_name_1.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngWordMessageBoardSiteName1.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNgWord.messageBoardSiteName1 = true
  }
}, 200)
const checkNgWordMessageBoardSiteName2 = debounce(async () => {
  const queryData = { sentence: v$.value.message_board_site_name_2.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngWordMessageBoardSiteName2.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNgWord.messageBoardSiteName2 = true
  }
}, 200)
const checkNgWordMessageBoardSiteName3 = debounce(async () => {
  const queryData = { sentence: v$.value.message_board_site_name_3.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngWordMessageBoardSiteName3.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNgWord.messageBoardSiteName3 = true
  }
}, 200)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('CO40title')), 1),
      (serverError.value)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            title: _unref(translate)('CO40messageError')
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      (_unref(dataCommunity)?.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (!_unref(dataCommunity)?.loading)
        ? (_openBlock(), _createElementBlock("form", {
            key: 2,
            onSubmit: _cache[34] || (_cache[34] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('communityName')), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "communityName",
                    class: _normalizeClass(['form-control', _unref(v$).name.$error ? 'is-invalid' : '']),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event)),
                    placeholder: _unref(translate)('placeholder')
                  }, null, 10, _hoisted_11), [
                    [
                      _vModelText,
                      _unref(v$).name.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('communityName'),
                    validator: _unref(v$).name.$errors[0]?.$validator,
                    params: [1, 30]
                  }, null, 8, ["title", "validator"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)('publicOrganizationName')), 1),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "publicOrganizationName",
                      class: _normalizeClass(['form-control', _unref(v$).display_corporation_name.$error ? 'is-invalid' : '']),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).display_corporation_name.$model) = $event)),
                      placeholder: _unref(translate)('placeholder')
                    }, null, 10, _hoisted_18), [
                      [
                        _vModelText,
                        _unref(v$).display_corporation_name.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('publicOrganizationName'),
                      validator: _unref(v$).display_corporation_name.$errors[0]?.$validator,
                      params: [1, 30]
                    }, null, 8, ["title", "validator"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(translate)('CO40text1')), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, _toDisplayString(_unref(translate)('managementOfficeName')), 1),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "managementOfficeName",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).operating_name.$model) = $event)),
                    class: _normalizeClass(['form-control', _unref(v$).operating_name.$error ? 'is-invalid' : '']),
                    placeholder: _unref(translate)('placeholder')
                  }, null, 10, _hoisted_26), [
                    [
                      _vModelText,
                      _unref(v$).operating_name.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(translate)('notEnteredCase')), 1),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('managementOfficeName'),
                    validator: _unref(v$).operating_name.$errors[0]?.$validator,
                    params: [30]
                  }, null, 8, ["title", "validator"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(translate)('explanatoryText')), 1),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("textarea", {
                    placeholder: _unref(translate)('placeholder'),
                    name: "explanatoryText",
                    class: _normalizeClass(['form-control', _unref(v$).description.$error ? 'is-invalid' : '']),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).description.$model) = $event)),
                    rows: "4"
                  }, "\n            ", 10, _hoisted_33), [
                    [
                      _vModelText,
                      _unref(v$).description.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('explanatoryText'),
                    validator: _unref(v$).description.$errors[0]?.$validator,
                    params: [1, 200]
                  }, null, 8, ["title", "validator"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("label", _hoisted_35, _toDisplayString(_unref(translate)('messageBoard')), 1),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("label", _hoisted_38, _toDisplayString(_unref(translate)('messageBoardTitle')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "messageBoardTitle",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).message_board_title.$model) = $event)),
                    class: _normalizeClass(['form-control', ngWordMessageBoardTitle.value || _unref(v$).message_board_title.$error ? 'is-invalid' : '']),
                    placeholder: _unref(translate)('messageBoard'),
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(checkNgWordMessageBoardTitle) && _unref(checkNgWordMessageBoardTitle)(...args)))
                  }, null, 42, _hoisted_39), [
                    [
                      _vModelText,
                      _unref(v$).message_board_title.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("p", _hoisted_40, _toDisplayString(_unref(translate)('messageBoardTitleNotEnteredCase')), 1),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('messageBoardTitle'),
                    validator: ngWordMessageBoardTitle.value ? 'ngWord' : _unref(v$).message_board_title.$errors[0]?.$validator,
                    params: [20]
                  }, null, 8, ["title", "validator"])
                ]),
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(translate)('messageBoardContent')), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    name: "messageBoardContent",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).message_board_content.$model) = $event)),
                    class: _normalizeClass(['form-control', ngWordMessageBoardContent.value || _unref(v$).message_board_content.$error ? 'is-invalid' : '']),
                    placeholder: _unref(translate)('placeholder'),
                    rows: "4",
                    onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(checkNgWordMessageBoardContent) && _unref(checkNgWordMessageBoardContent)(...args)))
                  }, "\n            ", 42, _hoisted_44), [
                    [
                      _vModelText,
                      _unref(v$).message_board_content.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('messageBoardContent'),
                    validator: ngWordMessageBoardContent.value ? 'ngWord' : _unref(v$).message_board_content.$errors[0]?.$validator,
                    params: [1000]
                  }, null, 8, ["title", "validator"]),
                  _hoisted_45
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_unref(translate)('messageBoardSiteName1')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "messageBoardSiteName1",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).message_board_site_name_1.$model) = $event)),
                    class: _normalizeClass(['form-control', ngWordMessageBoardSiteName1.value || _unref(v$).message_board_site_name_1.$error ? 'is-invalid' : '']),
                    placeholder: _unref(translate)('placeholder'),
                    onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(checkNgWordMessageBoardSiteName1) && _unref(checkNgWordMessageBoardSiteName1)(...args)))
                  }, null, 42, _hoisted_48), [
                    [
                      _vModelText,
                      _unref(v$).message_board_site_name_1.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('messageBoardSiteName1'),
                    validator: ngWordMessageBoardSiteName1.value ? 'ngWord' : _unref(v$).message_board_site_name_1.$errors[0]?.$validator,
                    params: [100]
                  }, null, 8, ["title", "validator"]),
                  _hoisted_49
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("label", _hoisted_51, _toDisplayString(_unref(translate)('messageBoardSiteUrl1')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "messageBoardSiteUrl1",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).message_board_site_url_1.$model) = $event)),
                    class: _normalizeClass(['form-control', _unref(v$).message_board_site_url_1.$error ? 'is-invalid' : '']),
                    placeholder: _unref(translate)('placeholder'),
                    onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_unref(v$).message_board_content.$validate && _unref(v$).message_board_content.$validate(...args)))
                  }, null, 42, _hoisted_52), [
                    [
                      _vModelText,
                      _unref(v$).message_board_site_url_1.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('messageBoardSiteUrl1'),
                    validator: _unref(v$).message_board_site_url_1.$errors[0]?.$validator,
                    params: [4096]
                  }, null, 8, ["title", "validator"]),
                  _hoisted_53
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_unref(translate)('messageBoardSiteName2')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "messageBoardSiteName2",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).message_board_site_name_2.$model) = $event)),
                    class: _normalizeClass(['form-control', ngWordMessageBoardSiteName2.value || _unref(v$).message_board_site_name_2.$error ? 'is-invalid' : '']),
                    placeholder: _unref(translate)('placeholder'),
                    onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_unref(checkNgWordMessageBoardSiteName2) && _unref(checkNgWordMessageBoardSiteName2)(...args)))
                  }, null, 42, _hoisted_56), [
                    [
                      _vModelText,
                      _unref(v$).message_board_site_name_2.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('messageBoardSiteName2'),
                    validator: ngWordMessageBoardSiteName2.value ? 'ngWord' : _unref(v$).message_board_site_name_2.$errors[0]?.$validator,
                    params: [100]
                  }, null, 8, ["title", "validator"]),
                  _hoisted_57
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("label", _hoisted_59, _toDisplayString(_unref(translate)('messageBoardSiteUrl2')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "messageBoardSiteUrl2",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(v$).message_board_site_url_2.$model) = $event)),
                    class: _normalizeClass(['form-control', _unref(v$).message_board_site_url_2.$error ? 'is-invalid' : '']),
                    placeholder: _unref(translate)('placeholder'),
                    onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_unref(v$).message_board_content.$validate && _unref(v$).message_board_content.$validate(...args)))
                  }, null, 42, _hoisted_60), [
                    [
                      _vModelText,
                      _unref(v$).message_board_site_url_2.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('messageBoardSiteUrl2'),
                    validator: _unref(v$).message_board_site_url_2.$errors[0]?.$validator,
                    params: [4096]
                  }, null, 8, ["title", "validator"]),
                  _hoisted_61
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("label", _hoisted_63, _toDisplayString(_unref(translate)('messageBoardSiteName3')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "messageBoardSiteName3",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(v$).message_board_site_name_3.$model) = $event)),
                    class: _normalizeClass(['form-control', ngWordMessageBoardSiteName3.value || _unref(v$).message_board_site_name_3.$error ? 'is-invalid' : '']),
                    placeholder: _unref(translate)('placeholder'),
                    onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_unref(checkNgWordMessageBoardSiteName3) && _unref(checkNgWordMessageBoardSiteName3)(...args)))
                  }, null, 42, _hoisted_64), [
                    [
                      _vModelText,
                      _unref(v$).message_board_site_name_3.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('messageBoardSiteName3'),
                    validator: ngWordMessageBoardSiteName3.value ? 'ngWord' : _unref(v$).message_board_site_name_3.$errors[0]?.$validator,
                    params: [100]
                  }, null, 8, ["title", "validator"]),
                  _hoisted_65
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("label", _hoisted_67, _toDisplayString(_unref(translate)('messageBoardSiteUrl3')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "messageBoardSiteUrl3",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(v$).message_board_site_url_3.$model) = $event)),
                    class: _normalizeClass(['form-control', _unref(v$).message_board_site_url_3.$error ? 'is-invalid' : '']),
                    placeholder: _unref(translate)('placeholder'),
                    onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_unref(v$).message_board_content.$validate && _unref(v$).message_board_content.$validate(...args)))
                  }, null, 42, _hoisted_68), [
                    [
                      _vModelText,
                      _unref(v$).message_board_site_url_3.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('messageBoardSiteUrl3'),
                    validator: _unref(v$).message_board_site_url_3.$errors[0]?.$validator,
                    params: [4096]
                  }, null, 8, ["title", "validator"]),
                  _hoisted_69
                ])
              ])
            ]),
            _createVNode(UploadImage, {
              title: _unref(translate)('headerLogo'),
              onSetImage: setHeaderLogoImage,
              initImage: initImage.value?.image_url,
              field: _unref(v$).image_url,
              setModelImage: (value) => setModelImage('image_url', value),
              params: [_unref(MAX_UPLOAD_FILE_SIZE_MB)]
            }, null, 8, ["title", "initImage", "field", "setModelImage", "params"]),
            _createVNode(UploadImage, {
              title: _unref(translate)('managementOfficeProfileImage'),
              onSetImage: setOfficeProfileImage,
              initImage: initImage.value?.profile_image_url,
              type: 'avatar',
              field: _unref(v$).profile_image_url,
              setModelImage: (value) => setModelImage('profile_image_url', value),
              noticeImage: _unref(translate)('CO40noticeImage'),
              params: [_unref(MAX_UPLOAD_FILE_SIZE_MB)]
            }, null, 8, ["title", "initImage", "field", "setModelImage", "noticeImage", "params"]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("label", _hoisted_71, _toDisplayString(_unref(translate)('publicSettings')), 1),
              _createElementVNode("div", _hoisted_72, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", {
                  class: _normalizeClass(['d-flex align-items-center  py-2', _unref(v$).published.$error ? 'is-invalid' : ''])
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(radioList, (item) => {
                    return _createElementVNode("div", {
                      class: "col-lg-3 form-check me-4",
                      key: item.title
                    }, [
                      _createElementVNode("label", {
                        class: "form-check-label fs-7 text-nowrap",
                        for: item.title
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          class: "form-check-input",
                          id: item.title,
                          value: item.status,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(v$).published.$model) = $event))
                        }, null, 8, _hoisted_75), [
                          [_vModelRadio, _unref(v$).published.$model]
                        ]),
                        _createTextVNode(" " + _toDisplayString(item.title), 1)
                      ], 8, _hoisted_74)
                    ])
                  }), 64))
                ], 2),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('publicSettings'),
                  validator: _unref(v$).published.$errors[0]?.$validator
                }, null, 8, ["title", "validator"]),
                _createElementVNode("p", _hoisted_76, _toDisplayString(_unref(translate)('CO40notice')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("label", _hoisted_78, _toDisplayString(_unref(translate)('invitationCodeSettings')), 1),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("label", _hoisted_82, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: "alumniCodeInvite",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.value.can_use_invited_code_of_alumni_users) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, formData.value.can_use_invited_code_of_alumni_users]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('almunai')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("label", _hoisted_84, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: "employeeCodeInvite",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.value.can_use_invited_code_of_employee_users) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, formData.value.can_use_invited_code_of_employee_users]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('employeeUser')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("p", _hoisted_85, _toDisplayString(_unref(translate)('invitationCodeNotCheckedCase')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("label", _hoisted_87, _toDisplayString(_unref(translate)('groupCreateSettings')), 1),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("label", _hoisted_91, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: "alumniGroupCreate",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formData.value.group_creation_by_alumni_users) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, formData.value.group_creation_by_alumni_users]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('almunai')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("label", _hoisted_93, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: "employeeGroupCreate",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formData.value.group_creation_by_employee_users) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, formData.value.group_creation_by_employee_users]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('employeeUser')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("p", _hoisted_94, _toDisplayString(_unref(translate)('groupCreateNotCheckedCase')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("label", _hoisted_96, _toDisplayString(_unref(translate)('CO40interestUserDisplaySetting')), 1),
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("label", _hoisted_100, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: "interestingRecruitment",
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formData.value.interest_display_setting_recruitment) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, formData.value.interest_display_setting_recruitment]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('recruitment')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("label", _hoisted_102, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: "interestingJobOffer",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((formData.value.interest_display_setting_joboffer) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, formData.value.interest_display_setting_joboffer]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('jobOffer')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("p", _hoisted_103, _toDisplayString(_unref(translate)('CO40interestUserDisplaySettingNote')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("label", _hoisted_105, _toDisplayString(_unref(translate)('pendingNoticeSettings')), 1),
              _createElementVNode("div", _hoisted_106, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("div", {
                  class: _normalizeClass(['d-flex align-items-center  py-2', _unref(v$).pending_notice.$error ? 'is-invalid' : ''])
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(NoticeRadioList, (item) => {
                    return _createElementVNode("div", {
                      class: "col-lg-3 form-check me-4",
                      key: item.title
                    }, [
                      _createElementVNode("label", {
                        class: "form-check-label fs-7 text-nowrap",
                        for: item.title
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          class: "form-check-input",
                          id: item.title,
                          value: item.status,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(v$).pending_notice.$model) = $event))
                        }, null, 8, _hoisted_109), [
                          [_vModelRadio, _unref(v$).pending_notice.$model]
                        ]),
                        _createTextVNode(" " + _toDisplayString(item.title), 1)
                      ], 8, _hoisted_108)
                    ])
                  }), 64))
                ], 2),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('pendingNoticeSettings'),
                  validator: _unref(v$).pending_notice.$errors[0]?.$validator
                }, null, 8, ["title", "validator"]),
                _createElementVNode("p", _hoisted_110, _toDisplayString(_unref(translate)('pendingNoticeNotSelectedCase')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("label", _hoisted_112, _toDisplayString(_unref(translate)('CO40emailNotificationInstant')), 1),
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("label", _hoisted_116, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: "settingComment",
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((formData.value.immediately_notice_setting_comment) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, formData.value.immediately_notice_setting_comment]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('CO40settingComment')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _createElementVNode("label", _hoisted_118, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: "settingMention",
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((formData.value.immediately_notice_setting_chatting) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, formData.value.immediately_notice_setting_chatting]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('CO40settingChatting')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_119, [
                  _createElementVNode("div", _hoisted_120, [
                    _createElementVNode("label", _hoisted_121, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: "settingChatting",
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((formData.value.immediately_notice_setting_mention) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, formData.value.immediately_notice_setting_mention]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('CO40settingMention')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_122, [
                    _createElementVNode("label", _hoisted_123, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: "settingInterested",
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((formData.value.immediately_notice_setting_interested) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, formData.value.immediately_notice_setting_interested]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('CO40settingInterested')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("p", _hoisted_124, _toDisplayString(_unref(translate)('CO40emailNoticeRegis')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_125, [
              _createElementVNode("label", _hoisted_126, _toDisplayString(_unref(translate)('unsupportedOperationsNoticeSettings')), 1),
              _createElementVNode("div", _hoisted_127, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_128, [
                _createElementVNode("div", {
                  class: _normalizeClass(['d-flex align-items-center  py-2', _unref(v$).unsupported_operations_notice.$error ? 'is-invalid' : ''])
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(NoticeRadioList, (item) => {
                    return _createElementVNode("div", {
                      class: "col-lg-3 form-check me-4",
                      key: item.unsupported_operations_notice_key
                    }, [
                      _createElementVNode("label", {
                        class: "form-check-label fs-7 text-nowrap",
                        for: item.unsupported_operations_notice_key
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          class: "form-check-input",
                          id: item.unsupported_operations_notice_key,
                          value: item.status,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(v$).unsupported_operations_notice.$model) = $event))
                        }, null, 8, _hoisted_130), [
                          [_vModelRadio, _unref(v$).unsupported_operations_notice.$model]
                        ]),
                        _createTextVNode(" " + _toDisplayString(item.title), 1)
                      ], 8, _hoisted_129)
                    ])
                  }), 64))
                ], 2),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('unsupportedOperationsNoticeSettings'),
                  validator: _unref(v$).unsupported_operations_notice.$errors[0]?.$validator
                }, null, 8, ["title", "validator"]),
                _createElementVNode("p", _hoisted_131, _toDisplayString(_unref(translate)('unsupportedOperationsNoticeNotSelectedCase')), 1)
              ])
            ]),
            (_unref(dataCommunity).yelloop_check_enable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                  _createElementVNode("label", _hoisted_133, _toDisplayString(_unref(translate)('CO40YelloopCheckFollowTitle')), 1),
                  _createElementVNode("div", _hoisted_134, [
                    _createVNode(Status)
                  ]),
                  _createElementVNode("div", _hoisted_135, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['row gy-3 align-items-center py-2 ps-3', _unref(v$).yelloop_check_update_follow_setting.$error ? 'is-invalid' : ''])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(YELLOOP_CHECK_FOLLOW_SETTING_LIST), ([key, title]) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "col-4 form-check me-0"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            id: String(key),
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(v$).yelloop_check_update_follow_setting.$model) = $event)),
                            type: "radio",
                            name: "yelloop_check_setting",
                            class: "form-check-input",
                            value: key
                          }, null, 8, _hoisted_136), [
                            [_vModelRadio, _unref(v$).yelloop_check_update_follow_setting.$model]
                          ]),
                          _createElementVNode("label", {
                            class: "form-check-label fs-7 text-nowrap",
                            for: String(key)
                          }, _toDisplayString(title), 9, _hoisted_137)
                        ]))
                      }), 128))
                    ], 2),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('CO40YelloopCheckFollowTitle'),
                      validator: _unref(v$).yelloop_check_update_follow_setting.$errors[0]?.$validator
                    }, null, 8, ["title", "validator"]),
                    _createElementVNode("p", _hoisted_138, _toDisplayString(_unref(translate)('CO40YelloopCheckFollowExplain')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_139, [
              _createVNode(Button, {
                title: _unref(translate)('SG40top'),
                onClick: () => _unref(router).push(`/community/communities/${_unref(route).params?.id}/dashboard`),
                type: 'secondary',
                "class-name": 'me-2'
              }, null, 8, ["title", "onClick"]),
              _createVNode(Button, {
                title: _unref(translate)('confirm'),
                type: 'secondary',
                disabled: loading.value,
                loading: loading.value,
                onClick: onSubmit
              }, null, 8, ["title", "disabled", "loading"])
            ])
          ], 32))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ConfirmModal, {
      data: { ...formData.value, ...initImage.value, headerLogoImage: headerLogoImage.value, officeProfileImage: officeProfileImage.value },
      showMessageError: showMessageError
    }, null, 8, ["data"]),
    _createVNode(CreateSuccessModal)
  ], 64))
}
}

})